<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons class="ion-text-left" slot="start" (click)="onDismiss()">
      <ion-button>
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title> {{ lineitem.name }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form [formGroup]="lineItemForm">
    <ion-card>
      <ion-card-content>
        <!--     <ion-item>
        <ion-label stacked>Price: </ion-label>
        <ion-input type="number" placeholder="0.00" name='' formControlName='price' clearInput></ion-input>
      </ion-item> -->

        <smr-stylist-picker
          *ngIf="lineitem.type == 'product'"
          [stylistID]="lineitem.stylistID"
          (stylistSelect)="onStylistSelect($event)"
          cssClass="smr-stylist-picker-for-productspicker"
        ></smr-stylist-picker>

        <div class="input-wrapper ion-padding">
          <!-- <ion-item> -->
          <ion-label position="stacked">Price</ion-label>

          <ion-input
            [maskito]="currencyMask"
            placeholder="Enter price"
            [maskitoElement]="maskPredicate"
            formControlName="price"
          >
          </ion-input>
          <!-- </ion-item> -->
        </div>

        <ion-item [hidden]="price.valid || (price.pristine)">
          <p *ngIf="price.hasError('required')" class="sm-error">
            Oops, a price is required.
          </p>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Quantity: </ion-label>
          <ion-input
            type="number"
            placeholder="0"
            name=""
            formControlName="quantity"
            [disabled]="lineitem.type != 'product'"
            clearInput
          ></ion-input>
        </ion-item>
        <ion-item [hidden]="quantity.valid || (quantity.pristine)">
          <p *ngIf="quantity.hasError('required')" class="sm-error">
            Oops, a quantity is required.
          </p>
        </ion-item>

        <ion-item>
          <!-- <ion-row>
          <ion-col> -->
          <ion-button
            expand="block"
            fill="clear"
            icon-left
            (click)="viewDiscountPicker($event)"
            *ngIf="!lineitem.discount"
          >
            Add Discount
          </ion-button>

          <ng-container *ngIf="lineitem.discount">
            <span> {{ lineitem.discount | discountLabel }} </span>
            <br />
            <h4>
              Price after discount: {{ lineitem.preTaxTotals |
              salonMonsterCurrency }}
            </h4>
          </ng-container>
          <!-- </ion-col> -->

          <div item-end *ngIf="lineitem.discount">
            <ion-button
              fill="clear"
              tappable
              (click)="viewDiscountPicker($event)"
            >
              <ion-icon name="create"></ion-icon>
            </ion-button>
            <ion-button fill="clear" tappable (click)="removeDiscount($event)">
              <ion-icon name="close"></ion-icon>
            </ion-button>
          </div>
          <!-- </ion-row> -->
        </ion-item>
      </ion-card-content>
    </ion-card>

    <ion-card>
      <!-- <ion-card-content> -->

      <ion-card-header> Taxes </ion-card-header>

      <ion-list>
        <!-- <ion-list-header>Taxes</ion-list-header> -->
        <ion-item *ngFor="let option of taxOptions">
          <ion-label>{{ option.tax.name }}</ion-label>
          <ion-toggle
            [formControlName]="option.formControlName"
            name=""
            (ionChange)="onTaxToggle()"
          ></ion-toggle>
        </ion-item>
      </ion-list>
      <!-- </ion-card-content> -->
    </ion-card>

    <!--     <ion-list radio-group>
    <ion-list-header>Discounts</ion-list-header>
    <ion-item *ngFor='let tax of sale.taxes'>
      <ion-label>{{ tax.name }}</ion-label>
      <ion-radio value="go"></ion-radio>
    </ion-item>
  </ion-list> -->
  </form>

  <ion-button
    fill="clear"
    expand="block"
    color="danger"
    *ngIf="showRemoveButton"
    (click)="removeItemClickHandler()"
    >Remove Item</ion-button
  >

  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>
  <!-- error occuredwhileloading products is never true -->
  <!-- <salonmonster-tap-retry
    *ngIf="errorOccurredWhileLoadingProducts"
    (click)="onTapToReload()"
  ></salonmonster-tap-retry> -->
</ion-content>
<ion-footer class="ion-no-border">
  <ion-button class="ion-no-margin" expand="block" (click)="save()">
    Save
  </ion-button>
</ion-footer>
